const baseUrl = process.env.REACT_APP_API_BASE_URL;
module.exports = {
  //Map data
  MapData:`${baseUrl}/api/ShipGeoLocation`,

  //Approval Dashboard
  PendingApprovalCount : `${baseUrl}/api/approver/pendingtasks/count/`,
  PendingApprovals : `${baseUrl}/api/approver/pendingtasks/`,
  EquipmentList :`${baseUrl}/api/approver/pendingtasks/equipment`,
  PostApproval : `${baseUrl}/api/approver/validation/equipmentservice`,
  ServiceImages : `${baseUrl}/api/approver/service-images?serviceId=`,
  PendingShipCount:`${baseUrl}/api/pendingCount`,


  MDSearch: `${baseUrl}/api/materialdeclarations`,
  MDDetail: `${baseUrl}/api/materialdeclaration`,
  MDMaterialInformation: `${baseUrl}/api/MaterialDeclaration/mdmaterials`,
  MDRelatedDocuments: `${baseUrl}/api/materialdeclaration/mdrelateddocuments/`,
  MasterMaterialInformation: `${baseUrl}/api/materialdeclaration/mastermaterials`,
  MDRemarksGet: `${baseUrl}/api/materialdeclaration/remarks`,

  //MD New Item Post method API'S
  MDPostAPI: `${baseUrl}/api/materialdeclaration`,
  MIPostAPI: `${baseUrl}/api/materialdeclaration/mdmaterials`,
  RDPostAPI: `${baseUrl}/api/materialdeclaration/mdrelateddocuments`,
  RemarkPostAPI: `${baseUrl}/api/materialdeclaration/mdremarks`,

  //MD Delete
  MDDelete: `${baseUrl}/api/materialdeclaration`,

  //MD item update

  MDUpdateAPI: `${baseUrl}/api/materialdeclaration`,
  MIUpdateAPI: `${baseUrl}/api/materialdeclaration/mdmaterials`,
  RDUpdateAPI: `${baseUrl}/api/materialdeclaration/mdrelateddocuments`,


  //Servicedate exist

  ServiceDateExist:`${baseUrl}/api/serviceData/exist`,

  //SMD Search

  SMDSearch: `${baseUrl}/api/suppliermaterialdeclarations`,
  SMDPostAPI: `${baseUrl}/api/suppliermaterialdeclaration`,

  //attachment upload
  DynamicAttachment: `${baseUrl}/api/attachment/dynamic/upload`,
  DynamicAttachments: `${baseUrl}/api/attachments/dynamic/upload`,
  AttachmentAPI: `${baseUrl}/api/attachment/upload`,
  DownloadAttachmentAPI: `${baseUrl}/api/attachment/download`,
  DownloadAttachmentServiceImages: `${baseUrl}/api/equipmentservice/serviceimages?equipmentServiceId=`,
  
  //FirePlan Attachment upload
  FirePlanAttachmentAPI: `${baseUrl}/api/attachment/upload`,

   //SMD delete
  SMDDelete: `${baseUrl}/api/suppliermaterialdeclaration/`,

  //reports API
  ReportAPI: `${baseUrl}/api/reports`,

  //ship report API
  ShipReportAPI:`${baseUrl}/api/ship/report`,
  //Users API
  UserAPI: `${baseUrl}/api/masteruser`,
  getUser: `${baseUrl}/api/masteruser/search`,
  getUserDetail: `${baseUrl}/api/user`,

  //login user Authentication
  AuthenticateUser: `${baseUrl}/api/login`,
  ADUsers: `${baseUrl}/api/adusers`,
  UserRole: `${baseUrl}/api/User/role`,

  //Inactiveship
  GetInactiveShips:`${baseUrl}/api/Ship/InActiveStatus`,

  //Ship Equipment Details
  ShipEquipmentCount: `${baseUrl}/api/ship/equipments/count?shipId=`,
  ShipDetail: `${baseUrl}/api/ship/details`,
  SearchShipEquipment: `${baseUrl}/api/equipment/search`,
  GetEquipmentInfo: `${baseUrl}/api/equipement/info`,
  GetEquipmentDetails: `${baseUrl}/api/equipement?shipId=`,
  GetEquipmentHistory: `${baseUrl}/api/equipment/history`,
  PostOwnerDetails:`${baseUrl}/api/Owner`,
  ServiceCost: `${baseUrl}/api/contract/ServiceOverView`,
  ContractUsersOptions: `${baseUrl}/api/Lookups/ClientUser`,
  ServiceBudget: `${baseUrl}/api/contract/BudgetPlan`,

  //MMPL Dasboard API
  MMPLShipCount: `${baseUrl}/api/ships/count`,
  SearchMMPLShipEquipment: `${baseUrl}/api/mmplship/search`,
  MMPLShipDetail: `${baseUrl}/api/ship/details?shipid=`,
  GetMMPLShipInfo: `${baseUrl}/api/equipement/info`,
  GetMMPLShipDetails: `${baseUrl}/api/equipement?shipId=`,
  GetMMPLShipHistory: `${baseUrl}/api/equipement/history?shipId=`,
  GetShipInfo: `${baseUrl}/api/ship/info`,

  //Contract Management API
  GetContractCount: `${baseUrl}/api/contracts/count`,
  GetContractSearch: `${baseUrl}/api/contract/search`,
  MMPLGetContractSearch: `${baseUrl}/api/MMPLContract/Search`,
  GetContractHistory: `${baseUrl}/api/contract/history`,
  GetContractDetail: `${baseUrl}/api/contract`,
  MMPLGetContractDetail: `${baseUrl}/api/MMPLContracts`,
  PutEditContractDetail: `${baseUrl}/api/contract`,
  GetContractClientName: `${baseUrl}/api/contract/ship`,
  PostContractDetails: `${baseUrl}/api/contract`,
  MMPLPostContractDetails: `${baseUrl}/api/MMPLContract`,
  MMPLStatusContractDetails: `${baseUrl}/api/MMPLContract/Status`,
  clientIMONo: `${baseUrl}/api/ship/clientAndImo`,
  contractDeleteOrTerminate: `${baseUrl}/api/ContractStatus`,

  //ServiceUpdate API
  PutServiceUpdate: `${baseUrl}/api/equipmentservice`,
  PutServiceUpdateImages: `${baseUrl}/api/equipmentservice/serviceimages`,
  GetServiceSearchEquipment: `${baseUrl}/api/serviceupdate/equipment`,

  //Ship Management
  getShipList: `${baseUrl}/api/masterships/search`,
  getShipDetail: `${baseUrl}/api/mastership`,
  postShipDetail: `${baseUrl}/api/mastership`,
  getShipEquipment: `${baseUrl}/api/mastershipequipment`,
  postShipEquipment: `${baseUrl}/api/mastership/Equipments`,
  getShipStatus:`${baseUrl}/api/shipstatuslist`,

  //Client Management
  getClientList: `${baseUrl}/api/masterclients/search`,
  getClientDetails: `${baseUrl}/api/masterclient`,
  getClientUsers: `${baseUrl}/api/ClientUsers`,
  postClient: `${baseUrl}/api/masterclient/users`,
  postClientuser: `${baseUrl}/api/masterclient/users`,
  getShipCount: `${baseUrl}/api/client/ShipCount`,

  //Client Users Master
  searchClientUsersMaster: `${baseUrl}/api/clientusersmaster/search`,
  getClientUsersMaster: `${baseUrl}/api/clientusersmaster`,
  createClientUsersMaster: `${baseUrl}/api/clientusersmaster`,
  updateClientUsersMaster: `${baseUrl}/api/clientusersmaster`,
  getUsersApplicableClients: `${baseUrl}/api/usersapplicableclients`,
  getAvailableClients: `${baseUrl}/api/usersapplicableclients/available`,
  assignUsersApplicableClient: `${baseUrl}/api/usersapplicableclients`,
  unassignUsersApplicableClient: `${baseUrl}/api/usersapplicableclients/unassign`,
  getClientUserVessels: `${baseUrl}/api/clientusersapplicableships`,
  syncClientUserVessels: `${baseUrl}/api/clientusersapplicableships`,

  //Equipment Management
  postEquipment: `${baseUrl}/api/masterequipment`,
  getEquipmentList: `${baseUrl}/api/masterequipment/search`,
  getEquipmentDetail: `${baseUrl}/api/masterequipment/info`,
  getShipSearch: `${baseUrl}/api/ship/search`,
  getEquipmentMakeModelandType:`${baseUrl}/api/equipmentDetails`,
  getShipEquipmentMakeModelandType:`${baseUrl}/api/shipEquipmentDetails`,
  equipmentExist:`${baseUrl}/api/equipment/exist`,
  getEquipmentApplicableServices: `${baseUrl}/api/equipment/ApplicableServices`,
  DeleteEquipment:`${baseUrl}/api/equipment/Delete`,

//Budget View
  getMultipleBudgetList:`${baseUrl}/api/multiplebudgetView`,
  getSingleBudgetList:`${baseUrl}/api/budgetView`,
  BudgetExistList:`${baseUrl}/api/BudgetExist`,
  postBudgetList:`${baseUrl}/api/contractAdd`,
  postselectZoneList:`${baseUrl}/api/ZoneDetailsAdd`,
  getselectZone:`${baseUrl}/api/ZoneDetails`,
  getPanelDetails:`${baseUrl}/api/contractDetails`,
  sendmailToApproveContract :`${baseUrl}/api/EmailToApproveContract`,
  resendMailToContract:`${baseUrl}/api/ResendTSIContractEmail`,

  //EquipmentServiceUpdate
  getComplianceStatus:`${baseUrl}/api/complianceStatusView`,
  getEquipmentCycleYear:`${baseUrl}/api/ShipEquipmentServiceGet`,

  //Compliance View
  getComplianceList:`${baseUrl}/api/complianceView`,
  downloadComplianceList:`${baseUrl}/api/shipCompliance/excelreport`,
  //Graph View
  getGraphList:`${baseUrl}/api/graphView`,
  

  //Port Management
  postPort: `${baseUrl}/api/port`,
  getPortList: `${baseUrl}/api/ports/search`,
  portExist:`${baseUrl}/api/port/exist`,

  //Vendor Management
   getVendorList: `${baseUrl}/VendorEquipment/search`,
   postVendor: `${baseUrl}/VendorEquipment`,
   getVendorEquipmentList:`${baseUrl}/VendorWithEquipments`,
   deleteVendor:`${baseUrl}/VendorEquipmentDelete`,
   getVendorOptionList:`${baseUrl}/VendorDetails`,

   //Helper API
   getUnitList:`${baseUrl}/UnitList`,
   getZoneList:`${baseUrl}/ZoneList`,
   getFullZoneList:`${baseUrl}/api/ZoneList`,

  //Service Provider Management
  postServiceProvider: `${baseUrl}/api/serviceprovider`,
  getServiceProviderList: `${baseUrl}/api/serviceprovider/search`,

  //ControlledDoc
  CDocFolderList:`${baseUrl}/api/controldocument/search`,
  CDocFolderPost:`${baseUrl}/api/controldocument/folder`,
  CDocUrl:`${baseUrl}/api/controldocument/folder/`,///{folder_id}/file

  //HistoryofActions API
  getHistorySearch:`${baseUrl}/api/historyoflogs`,

  //helpers
  FlagList: `${baseUrl}/api/flaglist`,
  Clientlist: `${baseUrl}/api/clientlist`,
  ClientUserlist: `${baseUrl}/api/clientUserslist`,
  EquipmentName: `${baseUrl}/api/equipmentlist`,
  EquipmentNameAndId: `${baseUrl}/api/equipmentAndId`,
  lookupNamelist: `${baseUrl}/api/lookuplist`,
  shipNames: `${baseUrl}/api/shiplist`,
  portList: `${baseUrl}/api/portlist`,
  portAndCountry: `${baseUrl}/api/portAndCountry`,
  serviceProviderPortAndCountry: `${baseUrl}/api/serviceProviderPortAndCountry`,
  serviceProviderPortAndCountryV2: `${baseUrl}/api/serviceProviderPortAndCountryV2`,
  ServiceType: `${baseUrl}/api/ServiceTypeList`,
  ServiceTypeInterval: `${baseUrl}/api/ServiceTypeListWithInterval`,
  EquipmentDropDown: `${baseUrl}/api/equipment/select`,
  EquipmentUsed: `${baseUrl}/api/Equipment/Used`,
  ServiceTypeUsed: `${baseUrl}/api/ServiceType/Used`,
  getServiceRequest: `${baseUrl}/api/ship/serviceStatus/generate`,
  EnrollmentUserlist:`${baseUrl}/api/roleDropdown`,
  AttachmentDelete : `${baseUrl}/api/attachment/delete`,
  //due
  ServiceDue: `${baseUrl}/api/ServiceDates`,

  //lookup
  postlookup: `${baseUrl}/api/lookup`,
  lookupsearch: `${baseUrl}/api/lookup/search`,
  lookupExist: `${baseUrl}/api/lookup/exist`,
  lookupIntervalExist:`${baseUrl}/api/interval/exist`,

  //Class
  getClassAopplicableService:`${baseUrl}/api/Class/EquipmentServices`,
  postClassApplicableServices:`${baseUrl}/api/Class/EquipmentServices`,
  putClassApplicableServices:`${baseUrl}/api/Class/ApplicableServices`,
 
  //Flag
  flagExist:`${baseUrl}/api/flag/exist`,
  postFlag: `${baseUrl}/api/Flag`,
  flagSearch: `${baseUrl}/api/Flag/search`,
  flagApplicableServices: `${baseUrl}/api/Flag/ApplicableServices`,

  //Misc
  miscExist:`${baseUrl}/api/misc/exist`,
  getMisctypeDropdownList:`${baseUrl}/api/miscTypes`,
  getMiscApplicableService:`${baseUrl}/api/Misc/ApplicableServices`,
  postMiscApplicableService:`${baseUrl}/api/Misc/ApplicableServices`,
  putMiscApplicableService:`${baseUrl}/api/Misc/ApplicableServices`,

  //export
  poStatusExport: `${baseUrl}/api/PO/Export`,
  downloadEquipmentStatus: `${baseUrl}/api/EquipmentStatus`,

  //staff
  getShipStaffs: `${baseUrl}/api/ShipStaff/shipstaffs`,
  postShipStaff: `${baseUrl}/api/ShipStaff/shipstaff`,
  putShipStaff: `${baseUrl}/api/ShipStaff/shipstaff`,

  //service type
  GetServiceTypeList: `${baseUrl}/api/ServiceTypeList`,
  GetEquipmentServiceTypeList: `${baseUrl}/api/equipmentservices`,
  EquipmentServiceIntervalList:`${baseUrl}/api/EquipmentServicesInterval`,

  //ServiceUpdateRange
  GetServiceRange:`${baseUrl}/api/equipmentApplicableServiceGet`,

  //Exist User Check
  userExist: `${baseUrl}/api/User/Exist`,

  // IdentityServer
  password: `${baseUrl}/api/ChangePassword`,

  // NoteManagement
  GetShipNote: `${baseUrl}/api/ship/Notes`,
  DeleteNote: `${baseUrl}/api/ship/Notes`,
  AddNote: `${baseUrl}/api/ship/Note`,
  UpdateNote: `${baseUrl}/api/ship/Note`,

  //Make and Model
  MakesList:`${baseUrl}/api/makelist`,
  Modelslist:`${baseUrl}/api/modellist`,
  MakeSearch:`${baseUrl}/api/lookup/makesearch`,
  PostMakeModel:`${baseUrl}/api/lookup`,
  GetOthersList:`${baseUrl}/api/modelothers`,

  //ContractScreen
  GetTermsandCondition:`${baseUrl}/api/TermsAndConditionsGet`,
  PutTermsCondition:`${baseUrl}/api/TermsAndConditionsUpdate`,
  GetCustomField:`${baseUrl}/api/CustomFieldsGet`,
  PutCustomField:`${baseUrl}/api/CustomFieldsUpdate`,
  PostServiceProviderPTF:`${baseUrl}/api/ServiceAgreementPost`,
  GetAgreement:`${baseUrl}/api/shipAgreement`,
  GetAAAServices:`${baseUrl}/api/additionalServices`,
  DownloadEquipmentServiceDetails:`${baseUrl}/api/equipmentServiceDetails/excelreport`,
  discountTypes:`${baseUrl}/api/DiscountTypes`,

  // Ship note endpoint
  shipNotes: `${baseUrl}/api/ship/ShipServiceNote`,
  shipNotesDelete: `${baseUrl}/api/ship/DeleteShipServiceNote`,

  // zone cost configuration
  costConfig: `${baseUrl}/api/equipments/ZoneCosts`,
  ShipcostConfig: `${baseUrl}/api/equipments/ShipEquipmentZoneCosts`,
  zoneCostList:`${baseUrl}/api/equipments/ZoneCostList`,
  ShipzoneCostList:`${baseUrl}/api/equipments/ShipEquipment/ZoneCostList`,
  budgetReport: `${baseUrl}/api/contract/Report`,
  equipmentLookups: `${baseUrl}/api/Lookups`,
  adhocGet: `${baseUrl}/api/equipments/AdHocServices`,
  downloadExcel:`${baseUrl}/api/equipments/AdHocServices/report`,

  //Verify API's
  VerifyShipContractField: `${baseUrl}/api/contract/CheckContract?shipId=`,
  VerifyContractShip: `${baseUrl}/api/contract/CheckActiveContracts?shipId=`
  };
